<template>
  <div class="row" style="margin-top: 5%">
    <Loading :active.sync="isLoading"
             :is-full-page="isFullPage"></Loading>
    <div class="col-md-12 text-left">
      <b-button style="margin-left: 20px" size="sm"  variant="success" @click="goBack">
      Geri
    </b-button>
    </div>
    <div class="col-md-6" style="margin-left: 5%" v-show="cozulenDenemeler.length > 0">
      <div class="col-md-12">
        <h3>Sınav Çözümleriniz</h3>
        <div class="col-md-12 text-center"><font-awesome-icon :icon="['fas', 'bullseyePointer']" size="6x" /></div>
      </div>
      <div class="col-md-12">
        <p>Bu sınavı bugüne kadar <strong>{{cozulenDenemeler.length}}</strong> defa çözdünüz!</p>
      </div>
      <div class="col-md-10">
      <b-table hover :items="cozulenDenemeler" :fields="alanlar">
        <template slot="baslamaTarihi"  slot-scope="data">
          {{data.item.baslamaTarihi | moment("DD-MM-YYYY HH:mm:ss")}}
        </template>
        <template slot="bitirmeTarihi"  slot-scope="data">
          {{data.item.bitirmeTarihi | moment("DD-MM-YYYY HH:mm:ss")}}
        </template>
        <template slot="secenekler"  slot-scope="data">
          <b-button size="sm"  variant="primary" :to="{name: 'SinavOzeti', params: { sinavid: data.item._id }}">
            Sınav Detayı Gör
          </b-button>
        </template>
      </b-table>
      </div>
    </div>
    <div class="col-md-5 text-center" style="padding-left: 20px;margin: 0" v-show="cozulenDenemeler.length > 0">
      <b-img fluid src="../assets/images/istatistik.jpg"/>
    </div>
    <div v-if="cozulenDenemeler.length == 0" class="d-flex flex-row text-center h-95 justify-content-center align-items-center col-md-12">

     <div> <font-awesome-icon :icon="['fal', 'sad-tear']" size="6x" /> </div>
      <div>
      <h3>Bu sınavı daha önce hiç çözmediniz</h3>
      <b-button size="sm" :to="{name: 'Sinav', params: { sinavid: denemeid }}" variant="success" class="mr-2">
        Şimdi Sınavı Çöz
      </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import {getEnteredQuiz} from '../utility/ajaxMethods'
import Loading from 'vue-loading-overlay'
export default {
  name: 'SinavDetayi',
  data: () => {
    return {
      denemeid: null,
      cozulenDenemeler: [],
      isLoading: false,
      alanlar: [{key: 'baslamaTarihi', label: 'Başlama'},
        {key: 'bitirmeTarihi', label: 'Bitiş'},
        {key: 'toplamDogruSayisi', label: 'Doğru Sayısı'},
        {key: 'toplamYanlisSayisi', label: 'Yanlış Sayısı'},
        {key: 'secenekler', label: 'Seçenekler'}],
      isFullPage: true
    }
  },
  methods: {
    ...mapActions([
      'Login_ACTION'
    ]),
    goBack () {
      window.history.length > 1
        ? this.$router.go(-1)
        : this.$router.push('/Sinavlarim')
    }
  },
  computed: {
    ...mapState([
      'user'
    ])
  },
  components: {
    Loading
  },
  async mounted () {
    this.isLoading = true
    const token = this.user.token
    const did = this.$route.params.denemeid
    this.denemeid = did
    const res = await getEnteredQuiz(token, did, this.$serviceAddress)
    if (res.err === '') {
      const cozulenDenemeler = res.result.cozulenDenemeler
      this.hata = ''
      this.cozulenDenemeler = cozulenDenemeler
    } else {
      this.hata = res.err
    }
    this.isLoading = false
  }
}
</script>

<style scoped>
  .secenek {
    padding-right: 10px;
  }
  .dogruSecenek {
    color:green;
  }
  .yanlisSecenek {
    color: darkred;
  }
  .cevap {
    color: greenyellow;
  }
  .h-95{
    height: 95vh;
  }
</style>



// WEBPACK FOOTER //
// src/components/SinavDetay.vue